// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2Tl5g","bigColWidth":"Table_bigColWidth__3cQ4F","biggerColWidth":"Table_biggerColWidth__1N8fs","row":"Table_row__ytlhN","col":"Table_col__VCoSF"};